import {
	API_GET_STREETS_POSTALCODE,
	API_GET_STREETS_POSTALCODE_SUCCESS,
	API_GET_STREETS_POSTALCODE_FAIL
} from '../actions/street';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
	workList: []
};

const streets = createReducer(initialState, {
	/** GET_STREETS_PSOTALCODE **/
	[API_GET_STREETS_POSTALCODE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_STREETS_POSTALCODE_FAIL]: (state, action) => {
		errorHandler('Rue', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_STREETS_POSTALCODE_SUCCESS]: (state, action) => {
		state.loading = false;
		if (action.meta.previousAction.work) state.workList = action.payload.data;
		else state.list = action.payload.data;
	}
});

export default streets;
